export default class RuleConfig {
  constructor({
    id = null,
    name = '',
    logPath = '',
    pattern = '',
    logFormat = '',
    logExample = '',
    openStatistics = '',
    delimiterSeparator = '',
    customize = null,
    results = [
      {
        key: '',
        value: ''
      }
    ],
    logType = ''
  }) {
    this.id = id;
    this.name = name;
    this.logPath = logPath;
    this.pattern = pattern;
    this.logFormat = logFormat;
    this.logExample = logExample;
    this.openStatistics = openStatistics;
    this.delimiterSeparator = delimiterSeparator;
    this.customize = customize;
    this.results = results;
    this.logType = logType;
  }
}
